import {
  BLUFI_FC_FRAG,
  BLUFI_FC_FRAG_MASK,
} from "@/services/blufi-constants.ts";

const hasSubsequentFragments = (frame: Uint8Array) =>
  (frame[1] & BLUFI_FC_FRAG_MASK) == BLUFI_FC_FRAG;

export const decodeNotification = (notif: DataView) => {
  const frame = new Uint8Array(notif.buffer);

  const type = frame[0] & 3;
  const subType = frame[0] >> 2;
  const sequence = frame[2];
  const len = frame[3];

  return {
    frame,
    type,
    subType,
    sequence,
    len,
    hasSubsequentFragments: hasSubsequentFragments(frame),
  };
};

export type DecodedFrame = ReturnType<typeof decodeNotification>;
